export const poiMarkerTypes = [
	{ value: 'info', text: 'Information' },
	{ value: 'loot', text: 'Loot' },
	{ value: 'danger', text: 'Danger' }
];
